/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_Group_LabelInputs */

const en_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select everything that describes you`)
};

const de_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie alles aus, was Sie beschreibt`)
};

const pt_br2_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione tudo o que descreve você`)
};

const tr_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizi tanımlayan her şeyi seçin`)
};

const zh_cn2_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择所有符合您的描述`)
};

const zh_hk2_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇所有符合您的描述`)
};

const ko_kr2_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회원님을 설명하는 항목을 모두 선택하세요`)
};

const ru_ru2_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите все подходящие вам утверждения`)
};

const es_419_onboarding_v1_profile_group_label = /** @type {(inputs: Onboarding_V1_Profile_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona todo lo que te describa`)
};

/**
* | output |
* | --- |
* | "Select everything that describes you" |
*
* @param {Onboarding_V1_Profile_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_group_label = /** @type {((inputs?: Onboarding_V1_Profile_Group_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_Group_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_group_label(inputs)
	if (locale === "de") return de_onboarding_v1_profile_group_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_group_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_group_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_group_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_group_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_group_label(inputs)
	return es_419_onboarding_v1_profile_group_label(inputs)
});